<template>
  <div>
    <OnboardingIndex
      title="Reset your password"
      :custom_submit_button="true"
      :verification_running="action_running"
    >
      <template v-slot:form-content>
        <div v-if="!link_verified" class="text-center mb-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Verifying link...</span>
          </div>
          <p class="mt-2">Verifying reset link...</p>
        </div>

        <div v-else>
          <div class="mb-4">
            <h6 class="text-dark text-xs">
              Please enter a new password below to complete the reset process.
            </h6>
          </div>

          <!-- New Password Field -->
          <div class="mb-3">
            <label for="password" class="form-label text-xs text-dark">New Password</label>
            <div class="input-group">
              <input
                :type="show_password ? 'text' : 'password'"
                class="form-control password form-control-lg text-xxs bg-light border-0 py-3"
                v-model="new_password"
                id="password"
                placeholder="Enter your new password"
                autocomplete="new-password"
                @input="validate_password($event.target.value)"
              />
              <i 
            :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
            class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2 mb-2"
            @click="toggle_password_visibility"
          ></i>
            </div>
          </div>

          <!-- Confirm Password Field -->
          <div class="mb-3">
            <label for="confirm_password" class="form-label text-xs text-dark">Confirm Password</label>
            <div class="input-group">
              <input
                :type="show_password ? 'text' : 'password'"
                class="form-control password form-control-lg text-xxs bg-light border-0 py-3"
                v-model="confirm_password"
                id="confirm_password"
                placeholder="Confirm your new password"
                autocomplete="new-password"
              />
              <i 
            :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
            class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2 mb-2"
            @click="toggle_password_visibility"
          ></i>
            </div>
          </div>

          <!-- Password Requirements -->
          <div class="mt-3 password-requirements">
            <p class="mb-2 text-dark text-xs">Password requirements:</p>
            <ul class="list-unstyled">
              <li v-for="(is_valid, requirement) in password_validation"
                  :key="requirement" 
                  class="mb-1 text-xxs me-1">
                <i :class="['bi', is_valid ? 'bi-check-circle-fill text-success me-1' : 'bi-circle text-muted me-1']"></i>
                <span :class="is_valid ? 'text-success' : 'text-muted'">
                  {{ get_requirement_text(requirement) }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <template v-slot:custom-button>
        <button
          v-if="link_verified"
          type="button"
          class="btn btn-primary-dark rounded-button shadow w-100 mt-3 text-xs"
          :disabled="action_running || !is_password_valid()"
          @click="reset_password"
        >
          Reset Password
        </button>
      </template>
    </OnboardingIndex>
  </div>
</template>
